import { CardStatus, Currency } from '@iw/core/entities';

import { DictionaryType } from '../helpers/types';

export const ACCOUNT_GROUP_TYPE = {
  SALARY: 'Salary',
  CLIENT: 'Client',
} as const;

export type AccountGroupType = DictionaryType<typeof ACCOUNT_GROUP_TYPE>;

export enum AccountType {
  BankCard = 'bank-card',
  FiatWallet = 'fiat-wallet',
  CryptoWallet = 'crypto-wallet',
  TreasurerWallet = 'treasurer-wallet',
}

export interface Account {
  balance: string;
  createdAt: string;
  currencyId: string;
  id: string;
  status: string;
  type: AccountGroupType;
  updatedAt: string;
  card: AccountCard;
  cardProduct: AccountCardProduct;
  address?: string;
  accountType?: AccountType; // Frontend property
  currency?: Currency; // Frontend property
  balanceInDefaultCurr?: string; // Frontend property
}

export interface AccountExternal {
  accountId?: string;
  currencyId: string;
  holderEmail?: string;
  holderFirstName?: string;
  holderLastName?: string;
  fullName?: string; // Frontend property
  isExternal?: boolean; // Frontend property
}

export interface AccountCard {
  id: string;
  pan: string;
  status: CardStatus;
  createdAt: string;
  cardHolder: string;
}

export interface AccountCardProduct {
  id: string;
  brand: string;
  bin: number;
  dailyVolumeLimit: string;
  monthlyVolumeLimit: string;
}
